import React, { useEffect, useState } from 'react';
import { Input, Space, Typography, message } from 'antd';
import { useAIBuilderApi } from '../../../api/aibuilder/aibuilder';
import { TDataset } from '../../../models/aibuilder/aibuilder';

export interface PurposeStationProps {
  dataset: TDataset;
  purpose: string;
  onChange: (value: string) => void;
  onDatasetChanged: () => void;
  editable: boolean;
}

const PurposeStation: React.FC<PurposeStationProps> = ({
  dataset,
  purpose,
  onChange,
  onDatasetChanged,
  editable,
}) => {
  const { updateDataset } = useAIBuilderApi();
  const [name, setName] = useState(dataset.name);

  useEffect(() => {
    setName(dataset.name);
  }, [dataset.name]);

  const saveName = async () => {
    const trimmed = name.trim();
    if (!trimmed || trimmed === dataset.name) {
      setName(dataset.name);
      return;
    }
    try {
      // Le backend refuse une mise à jour sans data_type : renvoyer le type existant.
      await updateDataset(dataset.id, { name: trimmed, data_type: dataset.data_type });
      onDatasetChanged();
    } catch (error: any) {
      message.error(error?.response?.data || error?.message || 'Renommage impossible.');
      setName(dataset.name);
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div>
        <Typography.Text strong>Comment veux-tu appeler ton IA ?</Typography.Text>
        <Input
          aria-label="Nom du dataset"
          value={name}
          disabled={!editable}
          onChange={(e) => setName(e.target.value)}
          onPressEnter={saveName}
          onBlur={saveName}
        />
      </div>
      <Typography.Text type="secondary">
        Type de données : {dataset.data_type === 'image' ? 'Images' : 'Texte'}
      </Typography.Text>
      <Typography.Text strong>À quoi va servir ton IA ? Décris-le en une phrase.</Typography.Text>
      <Input.TextArea
        aria-label="Intention de mon IA"
        placeholder="Ex : mon IA trie mes photos d'animaux"
        rows={4}
        value={purpose}
        disabled={!editable}
        onChange={(e) => onChange(e.target.value)}
      />
    </Space>
  );
};

export default PurposeStation;
